import { AdminApiClient, AuthenticatedApiClient } from '@guiker/booking-shared'
import { useAuthenticatedApiClient } from '@guiker/react-framework'

export const useAuthenticatedBookingApiClient = useAuthenticatedApiClient(AuthenticatedApiClient)
export const useAdminBookingApiClient = useAuthenticatedApiClient(AdminApiClient)
